import React from "react"
import { Typography } from "@mui/material"
import styled from "styled-components"

const CopyrightNoticeWrap = styled.div`
  width: 100%;
  padding: 0.5rem;
  text-align: center;
`

export default function CopyrightNotice(): React.ReactElement {
  return (
    <CopyrightNoticeWrap>
      <Typography variant="caption">
        Copyright ⓒ 2021 by Boston Consulting Group. All rights reserved.
      </Typography>
    </CopyrightNoticeWrap>
  )
}
